// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen_SNZoV {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
}

.attributeArea__Iq4x {
  display:flex;
  justify-content: flex-start;
  box-sizing: border-box;
}
.attributeArea__Iq4x:hover input {
  border-color: #D0D0D0;
}
.attributeArea__Iq4x.selected_KbBNM input {
  border-color: var( --purple );
}

.attributeArea__Iq4x.selected_KbBNM input[data-error=true] {
  border-color: var( --red );
}


.attributeNames_MIN8e {
  display : inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.attributeTitle_ZdmrZ {
  font-size : 16px;
  color : #222222;
  height : 34px;
}
.rootItemTitle_n7_U5 {
  border-bottom: 5px solid var( --background );
}

.attributeSubtitle_oYKzS {
  font-size : 14px;
  color : #999999;
}

.icon_GZOpC { 
  width : 34px;
  height: 34px;
  margin-right : 5px;
}

.attributeButtons_M40uC {
  display: inline-flex;
  font-size: 12px;
  color : #999999;
  align-items: center;

  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  visibility: visible;
  opacity: 0.10;
  transition: opacity 0.25s cubic-bezier(0, 0, 0.2, 1);
  margin-left: 10px;
}

.attribute_OKCe6 {
  display: flex;
  flex-direction: column;
}

.attributeArea__Iq4x {
  padding-top: 6px;
  padding-bottom: 6px;
}

.attributeButtons_M40uC.selected_KbBNM {
  opacity: 1;
}

.attributeArea__Iq4x:hover > .attributeButtons_M40uC {
  opacity: 1;
  visibility: visible;
}

.attributeGroup_UbEDZ .attributeButton_HXy4Q {
  padding-left:0px;
  padding-right:6px;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 34px;
  color:var( --grey );
}
.groupOpenButton_TnvpB.attributeButton_HXy4Q {
  padding-left:11px;
  padding-right:11px;
}

.collectionInfo_l8x6C {
  color: #D0D0D0;
}

.attributeGroup_UbEDZ .attributeButton_HXy4Q:focus, .attributeGroup_UbEDZ .attributeButton_HXy4Q:active, .attributeGroup_UbEDZ .attributeButton_HXy4Q:focus:active, .attributeGroup_UbEDZ .attributeButton_HXy4Q:active:focus {
  outline : none;
}
.attributeButton_HXy4Q > i {
  transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
}
.attributeButton_HXy4Q:hover {
  text-decoration: none !important;
    color:var( --purple ) !important;

}
.remove_daoYQ {
  color : #AA0000;
}
.attributeChildren_O6ds3 {
  position: relative;
  transform-origin: 50% 0 0;
  padding-left : 30px;
  opacity: 1;
  visibility: visible;
  /*transition: transform 0.35s cubic-bezier(0, 0, 0.2, 1);*/

}
.rootChildren_m4yFO {
  padding-left:0px;
}
.childrenClosed_r8r0s {
  /*transform: scaleY(0);
  visibility: hidden;
  opacity: 0;*/
}

.leftSide_voznG {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.attributeEditor_qZxNy {
  display: flex;
  height: 100%;
  flex:1;
}

.details_RH2a3 {
  position : absolute;
  top: 0;
  bottom: 0;
  right : 0;
  flex : 0 1 auto;
  margin : 0;
  display: inline-flex;
  flex-direction: column;
  width: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  background: var( --background );
  border-left: 1px solid #e5e5e5;
}

.leftSide_voznG .tree_veFYX {

  flex-grow: 2;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom:0;
  margin-left:10px;
  box-shadow : none;
}

.newItemGroup_SETEi {
  margin : 10px 10px 0 10px;
  background-color: #FFF;
  padding : 10px;
  /*border-left: solid 10px #9760DF;*/
  
  .newItemEntryPane_Cj4Gu {
    .currentSelectedGroup_AnlML {
      /*font-weight: bold;
      color : #000;*/
      min-width:0;
    }
  }
}

.newItemCTA_sOKGS {
  font-size : 20px;
  padding:4px;
  color : #39393E;
}
.newItemCTAHint_GRH6M {
  color : #39393E;
  font-size : 13px;
  padding-top : 4px;
  padding-bottom:10px;
  line-height:13px;
  font-weight: 300;
}
.newItemEntryPane_Cj4Gu {
  width : 100%;
}


.newItemInput_wIotx {
  flex-grow: 2;
  max-width: 24em;
}


.dialogContainer_KekED {
  padding: 2em;
}

.dialogContent_Te75m {
  padding : 2em;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
}
.dialogHeader_b1hO6 {
  padding : 10px;
  font-size : 14px;
}
.addDialogContent_YM15M {
  display: flex;
  flex-direction: column;
}
.addDialogList_AARBX {
  flex-grow: 1;
  overflow-y: auto;
  width : 100%;
  border-color : #eeeeee;
}

.unitSep_HlgmO {
  background: #3A37D7;
  color: white;
  display : flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding:10px;
}

.addDialogList_AARBX .unitItem_ly06E {

  display : flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

}


`, "",{"version":3,"sources":["webpack://./src/screens/attribute/style.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,mBAAmB;;EAEnB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,gCAAgC;IAC9B,gCAAgC;;AAEpC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,0DAA0D;;AAE5D;AACA;EACE,gBAAgB;AAClB;AACA;EACE;;cAEY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,SAAS;EACT,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mCAAmC;;EAEnC;IACE;MACE;oBACc;MACd,WAAW;IACb;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;AAErB","sourcesContent":["@import \"../../style/theme.css\";\n\n.screen {\n  width:100%;\n  height:100%;\n  display:flex;\n  flex-direction: column;\n}\n\n.attributeArea {\n  display:flex;\n  justify-content: flex-start;\n  box-sizing: border-box;\n}\n.attributeArea:hover input {\n  border-color: #D0D0D0;\n}\n.attributeArea.selected input {\n  border-color: var( --purple );\n}\n\n.attributeArea.selected input[data-error=true] {\n  border-color: var( --red );\n}\n\n\n.attributeNames {\n  display : inline-flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.attributeTitle {\n  font-size : 16px;\n  color : #222222;\n  height : 34px;\n}\n.rootItemTitle {\n  border-bottom: 5px solid var( --background );\n}\n\n.attributeSubtitle {\n  font-size : 14px;\n  color : #999999;\n}\n\n.icon { \n  width : 34px;\n  height: 34px;\n  margin-right : 5px;\n}\n\n.attributeButtons {\n  display: inline-flex;\n  font-size: 12px;\n  color : #999999;\n  align-items: center;\n\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n  visibility: visible;\n  opacity: 0.10;\n  transition: opacity 0.25s cubic-bezier(0, 0, 0.2, 1);\n  margin-left: 10px;\n}\n\n.attribute {\n  display: flex;\n  flex-direction: column;\n}\n\n.attributeArea {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.attributeButtons.selected {\n  opacity: 1;\n}\n\n.attributeArea:hover > .attributeButtons {\n  opacity: 1;\n  visibility: visible;\n}\n\n.attributeGroup .attributeButton {\n  padding-left:0px;\n  padding-right:6px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  height: 34px;\n  color:var( --grey );\n}\n.groupOpenButton.attributeButton {\n  padding-left:11px;\n  padding-right:11px;\n}\n\n.collectionInfo {\n  color: #D0D0D0;\n}\n\n.attributeGroup .attributeButton:focus, .attributeGroup .attributeButton:active, .attributeGroup .attributeButton:focus:active, .attributeGroup .attributeButton:active:focus {\n  outline : none;\n}\n.attributeButton > i {\n  transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n.attributeButton:hover {\n  text-decoration: none !important;\n    color:var( --purple ) !important;\n\n}\n.remove {\n  color : #AA0000;\n}\n.attributeChildren {\n  position: relative;\n  transform-origin: 50% 0 0;\n  padding-left : 30px;\n  opacity: 1;\n  visibility: visible;\n  /*transition: transform 0.35s cubic-bezier(0, 0, 0.2, 1);*/\n\n}\n.rootChildren {\n  padding-left:0px;\n}\n.childrenClosed {\n  /*transform: scaleY(0);\n  visibility: hidden;\n  opacity: 0;*/\n}\n\n.leftSide {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.attributeEditor {\n  display: flex;\n  height: 100%;\n  flex:1;\n}\n\n.details {\n  position : absolute;\n  top: 0;\n  bottom: 0;\n  right : 0;\n  flex : 0 1 auto;\n  margin : 0;\n  display: inline-flex;\n  flex-direction: column;\n  width: 450px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: var( --background );\n  border-left: 1px solid #e5e5e5;\n}\n\n.leftSide .tree {\n\n  flex-grow: 2;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-bottom:0;\n  margin-left:10px;\n  box-shadow : none;\n}\n\n.newItemGroup {\n  margin : 10px 10px 0 10px;\n  background-color: #FFF;\n  padding : 10px;\n  /*border-left: solid 10px #9760DF;*/\n  \n  .newItemEntryPane {\n    .currentSelectedGroup {\n      /*font-weight: bold;\n      color : #000;*/\n      min-width:0;\n    }\n  }\n}\n\n.newItemCTA {\n  font-size : 20px;\n  padding:4px;\n  color : #39393E;\n}\n.newItemCTAHint {\n  color : #39393E;\n  font-size : 13px;\n  padding-top : 4px;\n  padding-bottom:10px;\n  line-height:13px;\n  font-weight: 300;\n}\n.newItemEntryPane {\n  width : 100%;\n}\n\n\n.newItemInput {\n  flex-grow: 2;\n  max-width: 24em;\n}\n\n\n.dialogContainer {\n  padding: 2em;\n}\n\n.dialogContent {\n  padding : 2em;\n  max-height: 75vh;\n  display: flex;\n  flex-direction: column;\n}\n.dialogHeader {\n  padding : 10px;\n  font-size : 14px;\n}\n.addDialogContent {\n  display: flex;\n  flex-direction: column;\n}\n.addDialogList {\n  flex-grow: 1;\n  overflow-y: auto;\n  width : 100%;\n  border-color : #eeeeee;\n}\n\n.unitSep {\n  background: #3A37D7;\n  color: white;\n  display : flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding:10px;\n}\n\n.addDialogList .unitItem {\n\n  display : flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `screen_SNZoV`,
	"attributeArea": `attributeArea__Iq4x`,
	"selected": `selected_KbBNM`,
	"attributeNames": `attributeNames_MIN8e`,
	"attributeTitle": `attributeTitle_ZdmrZ`,
	"rootItemTitle": `rootItemTitle_n7_U5`,
	"attributeSubtitle": `attributeSubtitle_oYKzS`,
	"icon": `icon_GZOpC`,
	"attributeButtons": `attributeButtons_M40uC`,
	"attribute": `attribute_OKCe6`,
	"attributeGroup": `attributeGroup_UbEDZ`,
	"attributeButton": `attributeButton_HXy4Q`,
	"groupOpenButton": `groupOpenButton_TnvpB`,
	"collectionInfo": `collectionInfo_l8x6C`,
	"remove": `remove_daoYQ`,
	"attributeChildren": `attributeChildren_O6ds3`,
	"rootChildren": `rootChildren_m4yFO`,
	"childrenClosed": `childrenClosed_r8r0s`,
	"leftSide": `leftSide_voznG`,
	"attributeEditor": `attributeEditor_qZxNy`,
	"details": `details_RH2a3`,
	"tree": `tree_veFYX`,
	"newItemGroup": `newItemGroup_SETEi`,
	"newItemEntryPane": `newItemEntryPane_Cj4Gu`,
	"currentSelectedGroup": `currentSelectedGroup_AnlML`,
	"newItemCTA": `newItemCTA_sOKGS`,
	"newItemCTAHint": `newItemCTAHint_GRH6M`,
	"newItemInput": `newItemInput_wIotx`,
	"dialogContainer": `dialogContainer_KekED`,
	"dialogContent": `dialogContent_Te75m`,
	"dialogHeader": `dialogHeader_b1hO6`,
	"addDialogContent": `addDialogContent_YM15M`,
	"addDialogList": `addDialogList_AARBX`,
	"unitSep": `unitSep_HlgmO`,
	"unitItem": `unitItem_ly06E`
};
export default ___CSS_LOADER_EXPORT___;
